const config = {
  state: {
    isConfigEditing: false,
    rejectConfigEditing: false,
    saveConfigEditing: false,
    configRules: {
      objName: [
        {
          required: true,
          message: '값을 입력해주세요.',
          trigger: 'blur',
        },
      ],
      ipaddressIpv4: [
        {
          pattern: '^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
          message: 'IPv4에 맞는 형식으로 입력해주세요.',
          trigger: 'blur',
        },
      ],
      ipaddressIpv6: [
        {
          pattern:
            '^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$',
          message: 'IPv6에 맞는 형식으로 입력해주세요.',
          trigger: 'blur',
        },
      ],
      objMacaddress: [
        {
          pattern: '^([0-9a-fA-F][0-9a-fA-F][:-]){5}[0-9a-fA-F]{2}$',
          message: 'Mac주소에 맞는 형식으로 입력해주세요.',
          trigger: 'blur',
        },
      ],
    },
  },
  mutations: {
    setConfigEditing: (state, isEditing) => {
      state.isConfigEditing = isEditing;
    },
    setRejectConfigEditing: (state, isReject) => {
      state.rejectConfigEditing = isReject;
    },
    setSaveConfigEditing: (state, doSave) => {
      state.saveConfigEditing = doSave;
    },
  },
  actions: {
    setConfigEditing({ commit }, flag) {
      // 수정모드인지 아닌지 판단
      commit('setConfigEditing', flag);
    },
    cancleConfigEdit({ commit }) {
      // 데이터를 원본으로 돌리고 수정모드 끝내기
      commit('setRejectConfigEditing', true);
      commit('setConfigEditing', false);
    },
    endConfigEdit({ commit }) {
      // 플래그값 초기화
      commit('setRejectConfigEditing', false);
      commit('setSaveConfigEditing', false);
      commit('setConfigEditing', false);
    },
    initRejectConfig({ commit }) {
      // 데이터 값 돌리기 (ex)취소
      commit('setRejectConfigEditing', false);
    },
    setSaveConfigEditing({ commit }, flag) {
      // 저장 동작 여부
      commit('setSaveConfigEditing', flag);
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/store/modules/config.js